/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-async-promise-executor */
// NOTE: 'events' is for storing an offline list of events to show when offline but 'syncEvents'
// is for storing offline submitted pending events to sync with back end when get online
import connector from '../connector';

const addEventMessagesList = (eventMessagesList) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('eventMessages', 'readwrite');
        const eventMessagesStore = transaction.objectStore('eventMessages');

        eventMessagesStore.clear(); // delete all of the previously added animals to add the new list

        eventMessagesList.forEach(singleEventMessage => {
            eventMessagesStore.add(singleEventMessage);
        });

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getEventMessagesListByEventId = (eventId) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('eventMessages', 'readonly');
        const eventMessagesStore = transaction.objectStore('eventMessages');
        const eventIdIndex = eventMessagesStore.index('EventIdIndex');


        const modifiedEventId = eventId === 'support' ?
            parseInt(localStorage.getItem('support_log')) : parseInt(eventId);

        const allEventMessages = eventIdIndex.getAll(modifiedEventId);

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: allEventMessages.result });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const events = {
    addEventMessagesList,
    getEventMessagesListByEventId
}

export default events;
